import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { AgentStatusEnum } from '../enums/agent-status.enum';
import { AgentTypeEnum } from '../enums/agent-type.enum';

/**
 * Agent DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.AGENT)
export class AgentSearchDto extends BaseSearchDto {
  uuid!: string;
  code!: string;
  status!: AgentStatusEnum;
  type!: AgentTypeEnum;
  contactShortName?: string | null;
  agentCategoryId?: number | null;
  agentCategoryName?: string | null;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
}
